<script>
    import {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import cart from "../stores/cart";
    import R, {LOADER} from "../lib/requests";
    import {PAYMENT_METHOD, PRODUCT_TYPE, SHIPPING_METHOD} from "../lib/constants";
    import {copyObject, address2Str, calcVatPrice} from "../lib/lib";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Warning from "../components/pages/Warning.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Cart from "./Cart.svelte";

    const shippingMethods = [
        {id: SHIPPING_METHOD.COURIER, name: "Courier (ACS ή ΕΛΤΑ Courier)", info: "1 έως 3 εργάσιμες μέρες"},
        {id: SHIPPING_METHOD.STORE, name: "Παραλαβή από τα κεντρικά γραφεία", info: ""}
    ]

    const ERROR_STATUS = {
        NONE: 0,
        REQUIRES_ACCOUNT: 1,
        REQUIRES_SUBSCRIPTION: 2,
    }

    let paymentMethods = [
        {
            id: PAYMENT_METHOD.CARD,
            name: 'Πιστωτική / Χρεωστική Κάρτα',
            icon: 'credit-card',
            visible: true,
        },
        {
            id: PAYMENT_METHOD.COD,
            name: 'Αντικαταβολή',
            icon: 'eur',
            visible: true,
        },
        {
            id: PAYMENT_METHOD.BANK,
            name: 'Κατάθεση σε Τράπεζα',
            icon: 'bank',
            visible: true,
        }
    ];

    let order = {
        lastname: '',
        firstname: '',
        phone: '',
        email: '',
        afm: '',
        notes: '',
        address: '',
        city: '',
        postal_code: '',
        region_id: 0,
        bill_name: '',
        bill_address: '',
        bill_phone: '',
        bill_afm: '',
        bill_doy: '',
        bill_info: {},
        vat: $user.vat,
        products_price: 0,
        shipping_price: 0,
        cod_price: 0,
        vat_price: 0,
        total_price: 0,
        payment_method: PAYMENT_METHOD.CARD,
        shipping_method: SHIPPING_METHOD.COURIER,
    }

    let cartProducts = [];
    let userId = null;
    let account = null;
    let address = '';
    let phone = '';
    let incompleteData = false;
    let differentShippingAddress = 0;
    let differentBillData = 0;
    let codPrice = 0;
    let requiredSettlementOfDebts = false; // για την αγορά κάποιων προϊόντων απαιτείται τακτοποίηση οφειλών


    const initialize = () => {
        const onSuccess = result => {
            account = result.account;
            codPrice = result.cod_price;

            if (result.account) {
                if (account.mobile) {
                    phone = account.mobile;
                } else if (account.phone2) {
                    phone = account.phone2;
                } else if (account.phone1) {
                    phone = account.phone1;
                }

                address = address2Str(account.address, account.post_code, account.city);
                if (account.region_id) {
                    $cart.region_id = account.region_id;
                    cart.calculateTotals();
                }

                // check for incomplete account data
                if (!account.afm || !account.region_id || account.region_id == 0 || !phone || !address) {
                    incompleteData = true;
                }

                setBillData();
                calculateTotals();
            }
        }

        const onFailure = err => {
        };

        if (!$user.token) {
            return;
        }

        order.products = $cart.products;
        order.region_id = $cart.region_id;

        R.handle(R.order.initialize, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const initializeCheckout = () => {
        console.log("initializeCheckout", $cart.products);
        order.products_price = 0;
        requiredSettlementOfDebts = false;

        cartProducts = [];
        $cart.products.map(item => {
            let product = copyObject(item);

            order.products_price += item.price * item.quantity;

            if (product.requires_account && !$user.id) {
                product.error_status = ERROR_STATUS.REQUIRES_ACCOUNT;
                product.has_error = true;
            }

            if (product.requires_subscription && !user.canBuyServices()) {
                requiredSettlementOfDebts = true;
            }

            cartProducts.push(product);
        });

        calculateTotals();
    }

    const calculateTotals = () => {
        // init payment methods
        paymentMethods.map(item => {
            item.visible = true;
        });

        order.cod_price = order.payment_method == PAYMENT_METHOD.COD ? codPrice : 0;
        order.vat_price = 0;

        cartProducts.map(product => {
            if (product.no_vat == 0) {
                order.vat_price += calcVatPrice(product.price * product.quantity, order.vat);
            }
        });

        if (order.shipping_method == SHIPPING_METHOD.COURIER) {
            order.shipping_price = $cart.shipping_price;
        } else {
            // hide cod on pick up from the store
            // and allow only credicard
            paymentMethods[PAYMENT_METHOD.COD].visible = false;
            if (order.payment_method == PAYMENT_METHOD.COD) {
                order.payment_method = PAYMENT_METHOD.CARD;
            }

            order.shipping_price = 0;
            order.cod_price = 0;
        }

        paymentMethods = paymentMethods;

        if (order.shipping_price > 0) {
            order.vat_price += calcVatPrice(order.shipping_price, order.vat);
        }
        if (order.cod_price > 0) {
            order.vat_price += calcVatPrice(order.cod_price, order.vat);
        }

        order.total_price = order.products_price + order.shipping_price + order.cod_price + order.vat_price;
    }

    const submit = () => {
        const onSuccess = result => {
            // save order hash to cart cookie
            $cart.order = result.hash;
            cart.saveCookie();
            window.open(result.move_to, "_self");
        }

        const onFailure = err => {
        };

        order.lastname = account.lastname;
        order.firstname = account.firstname;
        order.phone = phone;
        order.email = account.email;
        order.afm = account.afm;
        order.products = $cart.products;

        if (order.shipping_method == SHIPPING_METHOD.STORE || !differentShippingAddress) {
            order.address = account.address;
            order.city = account.city;
            order.postal_code = account.post_code;
            order.region_id = account.region_id;
        } else {
            order.region_id = $cart.region_id;
        }

        R.handle(R.order.create, order, onSuccess, onFailure, LOADER.POPUP);
    }

    const onRegionChange = () => {
        cart.saveCookie();
        cart.calculateTotals();
        calculateTotals();
    }

    const onPaymentMethodClick = method => {
        order.payment_method = method.id;
        calculateTotals();
    }

    const onShippingMethodClick = method => {
        order.shipping_method = method.id;
        calculateTotals();
    }

    const setBillData = () => {
        if (differentBillData == 1) {
            order.bill_name = '';
            order.bill_address = '';
            order.bill_phone = '';
            order.bill_afm = '';
            order.bill_doy = '';
        } else {
            order.bill_name = account.lastname + ' ' + account.firstname;
            order.bill_address = address;
            order.bill_phone = phone;
            order.bill_afm = account.afm;
            order.bill_doy = account.doy;
        }
    }

    if (!user.isActive()) {
        router.go('/account-error')()
    }

    $cart.updated = true;

    $:{
        if ($user.id == null) {
            userId = null;
        } else if ($user.id != userId) {
            initialize();
            userId = $user.id;
        }
        if ($cart.updated) {
            initializeCheckout();
            $cart.updated = false;
        }
    }
</script>

<div class="container">
    <h1>Ταμείο</h1>
    <div class="heading-separator mb-5"></div>

    {#if $user.id}
        {#if $user.status_id == 1}
            {#if account}
                {#if $cart.products.length}
                    <form on:submit|preventDefault|stopPropagation={ submit }>
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-pad-right">
                                <div class="mb-6">
                                    <legend>Προϊόντα - Υπηρεσίες</legend>
                                    <Cart products="{ cartProducts }"
                                          vat="{ order.vat }"
                                          productsPrice="{ order.products_price }"
                                          shippingPrice="{ order.shipping_price }"
                                          codPrice="{ order.cod_price }"
                                          vatPrice="{ order.vat_price }"
                                          totalPrice="{ order.total_price }"
                                    />
                                </div>

                                <div class="mb-6">
                                    <legend class="options-legend">Τρόπος Αποστολής</legend>
                                    <div class="options-list mb-5">
                                        {#each shippingMethods as item}
                                            <div class="option" class:selected={ order.shipping_method == item.id }
                                                 on:click={ () => onShippingMethodClick(item) }>
                                                { item.name }
                                                {#if item.info}
                                                    <div class="info">{ item.info }</div>
                                                {/if}
                                            </div>
                                        {/each}
                                    </div>
                                </div>

                                <div class="mb-6">
                                    <legend class="options-legend">Τρόπος Πληρωμής</legend>
                                    <div class="options-list mb-5">
                                        {#each paymentMethods as item}
                                            {#if item.visible}
                                                <div class="option" class:selected={ item.id == order.payment_method }
                                                     on:click={ () => onPaymentMethodClick(item) }>
                                                    <i class="fa fa-{ item.icon }"></i> { item.name }
                                                </div>
                                            {/if}
                                        {/each}
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-pad-left">
                                <div class="mb-6">
                                    <legend class="mb-4">Στοιχεία Μέλους</legend>
                                    <h2 class="mb-4">{ account.firstname } { account.lastname }</h2>
                                    <div class="mb-4">
                                        <h6>Α.Φ.Μ.</h6>
                                        {#if account.afm}
                                            { account.afm }
                                        {:else}
                                            <div class="text-danger">Δεν υπάρχει Α.Φ.Μ.</div>
                                        {/if}
                                    </div>
                                    <div class="mb-4">
                                        <h6>Τηλέφωνο</h6>
                                        {#if phone}
                                            { phone }
                                        {:else}
                                            <div class="text-danger">Δεν υπάρχει τηλέφωνο!</div>
                                        {/if}
                                    </div>
                                    <div class="mb-4">
                                        <h6>Email</h6>
                                        { account.email }
                                    </div>
                                    <div class="mb-4">
                                        <h6>Διεύθυνση</h6>
                                        {#if address}
                                            <div>{ address }</div>
                                        {:else}
                                            <div class="text-danger">Δεν υπάρχει διεύθυνση!</div>
                                        {/if}
                                        {#if account.region}
                                            <div>{ account.region.name }</div>
                                        {:else}
                                            <div class="text-danger">Δεν έχει οριστεί νομός!</div>
                                        {/if}
                                    </div>

                                    {#if incompleteData}
                                        <div class="alert alert-warning">
                                            Δεν είναι συμπληρωμένα όλα τα απαραίτητα στοιχεία του λογαριασμού σας!<br>
                                            Μεταβείτε στην σελίδα <a href="/my-account">"Ο λογαριασμός μου"</a> και
                                            συμπληρώστε τα στοιχεία που λείπουν για να μπορέσετε να ολοκληρώσετε την
                                            αγορά σας.
                                        </div>
                                    {/if}

                                    <Checkbox label="Τιμολόγιο σε διαφορετικά στοιχεία" cssClass="mb-3"
                                              bind:checked={differentBillData} disabled="{ incompleteData }"
                                              on:change={ setBillData }>
                                    </Checkbox>
                                    {#if differentBillData}
                                        <legend>Στοιχεία τιμολόγιου</legend>
                                        <div class="form-group">
                                            <label>Επωνυμία</label>
                                            <input type="text" class="form-control" bind:value="{ order.bill_name }"
                                                   required>
                                        </div>
                                        <div class="form-group">
                                            <label>Διεύθυνση</label>
                                            <input type="text" class="form-control" bind:value="{ order.bill_address }"
                                                   required>
                                        </div>
                                        <div class="form-group">
                                            <label>Τηλέφωνο</label>
                                            <input type="tel" class="form-control" bind:value="{ order.bill_phone }"
                                                   required>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col-md-6 form-group">
                                                <label>Α.Φ.Μ.</label>
                                                <input type="text" class="form-control" bind:value="{ order.bill_afm }"
                                                       required>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label>Δ.Ο.Υ.</label>
                                                <input type="text" class="form-control" bind:value="{ order.bill_doy }"
                                                       required>
                                            </div>
                                        </div>
                                    {/if}

                                    {#if order.shipping_method != SHIPPING_METHOD.STORE && cart.requiresAddress()}
                                        <Checkbox label="Αποστολή σε διαφορετική διεύθυνση"
                                                  bind:checked={differentShippingAddress} cssClass="mb-3"
                                                  disabled="{ incompleteData }"/>
                                    {/if}

                                    {#if order.shipping_method != SHIPPING_METHOD.STORE && differentShippingAddress == 1}
                                        <legend>Διεύθυνση Αποστολής</legend>
                                        <div class="form-group">
                                            <label>Νομός</label>
                                            <select class="form-select" bind:value="{ $cart.region_id }"
                                                    on:change={ onRegionChange } required>
                                                {#each $app.regions as region}
                                                    <option value="{ region.id }">{ region.name }</option>
                                                {/each}
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label>Διεύθυνση</label>
                                            <input type="text" class="form-control"
                                                   bind:value="{ order.address }" required>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-8">
                                                <div class="form-group">
                                                    <label>Πόλη</label>
                                                    <input type="text" class="form-control"
                                                           bind:value="{ order.city }" required>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="form-group">
                                                    <label>Τ.Κ.</label>
                                                    <input type="text" class="form-control"
                                                           bind:value="{ order.postal_code }" required>
                                                </div>
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                                <div class="order-total mb-6">
                                    Σύνολο παραγγελίας:
                                    <span class="text-primary fw-bold">{ order.total_price.toFixed(2) } €</span>
                                </div>
                                <p class="small text-gray">
                                    Παραγγελίες που λαμβάνονται έως τις 12μμ (μεσημέρι) αποστέλλονται αυθημερόν εφόσον
                                    υπάρχει απόθεμα. Μετά τις 12 το μεσημέρι αποστέλλονται στην επόμενη ημέρα.
                                </p>
                                <div class="form-group mb-6">
                                    <label>Σημειώσεις</label>
                                    <textarea class="form-control" bind:value="{ order.notes }"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6"></div>
                            <div class="col-lg-6 col-pad-left mb-5">
                                {#if requiredSettlementOfDebts}
                                    <div class="alert alert-danger">
                                        Για την αγορά κάποιον προϊόντων ή υπηρεσιών που έχετε επιλέξει απαιτείται η
                                        τακτοποίηση των οικονομικών σας οφειλών στον Π.Κ.Σ.
                                    </div>
                                {:else}
                                    <div class="form-check mb-3">
                                        <input class="form-check-input" type="checkbox" value="" id="checkTerms"
                                               required>
                                        <label class="form-check-label" for="checkTerms">
                                            Αποδέχομαι και συμφωνώ με τους <a
                                                href="https://www.hva.gr/el/content.php?page=terms" target="_blank"><b>Όρους
                                            Χρήσης</b></a>
                                        </label>
                                    </div>
                                    {#if order.payment_method == PAYMENT_METHOD.CARD}
                                        <button class="btn btn-lg btn-success btn-block" disabled="{ incompleteData }">
                                            Πληρωμή
                                        </button>
                                    {:else}
                                        <button class="btn btn-lg btn-success btn-block" disabled="{ incompleteData }">
                                            Ολοκλήρωση Παραγγελίας
                                        </button>
                                    {/if}
                                {/if}
                            </div>
                        </div>
                    </form>
                {:else}
                    <Warning warning="no-products" page="checkout"/>
                {/if}
            {/if}
        {:else}
            <Warning warning="account_not_active" page="checkout"/>
        {/if}
    {:else}
        <Warning warning="no-user" page="checkout"/>
    {/if}
</div>

<style>
    .options-legend {
        margin-bottom: 2px;
    }

    .options-list .option {
        position: relative;
        cursor: pointer;
        border-bottom: 1px solid #e4eaee;
        padding: 10px 15px;
    }

    .options-list .option:hover {
        background: #efefef;
    }

    .options-list .option i {
        display: inline-block;
        width: 25px;
    }

    .options-list .option .info {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        font-size: 14px;
        color: #777;
    }

    .options-list .option.selected {
        color: #fff;
        background: #06a7ea;
    }

    .options-list .option.selected .info {
        color: #fff;
    }

    .order-total {
        background: #f5f5f5;
        padding: 20px;
        text-align: center;
    }
</style>